import type { TFunction } from "i18next"

import type {
  AlertSettingParam,
  AlertSettingType,
  AlertSettingUpsertForm,
} from "types/alerts.types"

const DEFAULT_RANGE_CONDITION = "below"

export const getRangeDropdownOptions = (t: TFunction) => {
  const rangeDropdownOptions = [
    { label: t("alert_settings.IS_BELOW"), value: "below" },
    { label: t("alert_settings.IS_INSIDE_RANGE"), value: "inside" },
    { label: t("alert_settings.IS_OUTSIDE_RANGE"), value: "outside" },
    { label: t("alert_settings.IS_ABOVE"), value: "above" },
  ]
  const defaultRangeCondition = DEFAULT_RANGE_CONDITION
  return { rangeDropdownOptions, defaultRangeCondition }
}

export const getThresholdStatusOptions = (param: AlertSettingParam) =>
  param?.schema &&
  "type" in param.schema &&
  param.schema.type === "array" &&
  param?.schema?.items?.type === "object"
    ? param.schema.items.properties?.target?.enum?.map((item) => ({
        label: item.toUpperCase(),
        value: item.toUpperCase(),
      }))
    : undefined

export const getEmptyThreshold = (param: AlertSettingParam) => {
  const statusOptions = getThresholdStatusOptions(param)
  return {
    rangeCondition: DEFAULT_RANGE_CONDITION,
    above: undefined,
    below: undefined,
    inside: { from: undefined, to: undefined },
    outside: { from: undefined, to: undefined },
    alertStatus: statusOptions?.[0]?.value,
  }
}

export const getNewAlertSettingDefaultValues = (
  typeName: string,
  selectedType: AlertSettingType | undefined,
) => {
  const defaultValues: Partial<AlertSettingUpsertForm> = { type: typeName }

  // A new alert opens with one threshold to fill in.
  selectedType?.params.forEach((param) => {
    defaultValues[param.id] =
      param.id === "thresholds" ? [getEmptyThreshold(param)] : (param.default ?? "")
  })

  return defaultValues
}
